import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Home from "@/pages/Home";
import ServiceWeb from "@/pages/ServiceWeb";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Tietosuoja from "@/pages/Tietosuoja";
import { bindTrackClicks, trackPageview } from "@/lib/analytics";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    bindTrackClicks();
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors closeButton />
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/palvelut/verkkosivut" element={<ServiceWeb />} />
          <Route path="/tietosuoja" element={<Tietosuoja />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
